import type { MutableRefObject } from 'react';

export function syncAbortUiEscapeTimeout({
  isAbortUiActive,
  timeoutRef,
  onEscape,
  escapeMs,
}: {
  isAbortUiActive: boolean;
  timeoutRef: MutableRefObject<ReturnType<typeof setTimeout> | null>;
  onEscape: () => void;
  escapeMs: number;
}): void {
  if (!isAbortUiActive) {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }

    return;
  }

  if (timeoutRef.current) {
    return;
  }

  timeoutRef.current = setTimeout(() => {
    onEscape();
    timeoutRef.current = null;
  }, escapeMs);
}

export function clearAbortUiEscapeTimeout(
  timeoutRef: MutableRefObject<ReturnType<typeof setTimeout> | null>,
): void {
  if (timeoutRef.current) {
    clearTimeout(timeoutRef.current);
    timeoutRef.current = null;
  }
}
